import { Icons } from '../../icon/constants/icons.constants';
import { NotificationTypeKeys } from './notification-type.model';

export const getIcon = (type: NotificationTypeKeys): Icons.Type => {
    switch (type) {
        case 'success':
            return Icons.Alerts.circle_check;
        case 'error':
            return Icons.Alerts.circle_xmark;

        case 'warning':
            return Icons.Alerts.triangle_exclamation;

        case 'information':
        default:
            return Icons.Alerts.circle_info;
    }
};
